module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-03.53c04490.jpg";